import {hasTrackingConsent, normalizeEmailForGoogleAds, pushCustomDataLayer} from '@udemy-v2/gtag';

import {isJapanLocale} from '@/features/organization-team-plan/utils/is-japan-locale';

const DEFAULT_FORM_ID = 2657;
const JAPAN_FORM_ID = 4703;

function getMarketoFormId(locale: string): number {
    return isJapanLocale(locale) ? JAPAN_FORM_ID : DEFAULT_FORM_ID;
}

async function sha256ToHex(value: string): Promise<string> {
    const bytes = new TextEncoder().encode(value);
    const buffer = await crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(buffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

/**
 * Pushes `teamsFormSuccess` to GTM after a successful team plan signup.
 * Mirrors the event fired by old wordpress form.
 *
 * @param email - The user's raw email address.
 * @param locale - Udemy locale (e.g. 'en_US', 'ja_JP').
 */
export async function fireTeamsFormSuccessEvent(email: string, locale: string): Promise<void> {
    if (!hasTrackingConsent()) {
        return;
    }

    const formId = getMarketoFormId(locale);
    const sha256EmailAddress = await sha256ToHex(normalizeEmailForGoogleAds(email));

    pushCustomDataLayer({
        event: 'teamsFormSuccess',
        'gtm.elementId': `mktoForm_${formId}`,
        user_data: {
            sha256_email_address: sha256EmailAddress,
            email,
        },
    });
}
